module.exports = __webpack_public_path__ + "fonts/4b1b824.ttf";